// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import NotificationTypeAction from "./notification-type-action.js"
import NotificationTypeAuditTrigger from "./notification-type-audit-trigger.js"

const modelClassData = {
  "attributes": {
    "active": {
      "column": {
        "default": "1",
        "name": "active",
        "null": false,
        "type": "boolean"
      },
      "name": "active",
      "selected_by_default": null,
      "translated": false
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "notification_type_actions_count": {
      "column": {
        "default": "0",
        "name": "notification_type_actions_count",
        "null": false,
        "type": "integer"
      },
      "name": "notification_type_actions_count",
      "selected_by_default": null,
      "translated": false
    },
    "notification_type_audit_triggers_count": {
      "column": {
        "default": "0",
        "name": "notification_type_audit_triggers_count",
        "null": false,
        "type": "integer"
      },
      "name": "notification_type_audit_triggers_count",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "NotificationType",
  "collectionKey": "notification_types",
  "collectionName": "notification_types",
  "i18nKey": "notification_type",
  "camelizedLower": "notificationType",
  "name": "NotificationType",
  "nameDasherized": "notification-type",
  "pluralName": "notification_types",
  "ransackable_associations": [
    {
      "className": "NotificationTypeAction",
      "collectionName": "notification_type_actions",
      "foreignKey": "notification_type_id",
      "name": "actions",
      "macro": "has_many",
      "resource_name": "NotificationTypeAction",
      "through": null
    },
    {
      "className": "NotificationTypeAuditTrigger",
      "collectionName": "notification_type_audit_triggers",
      "foreignKey": "notification_type_id",
      "name": "audit_triggers",
      "macro": "has_many",
      "resource_name": "NotificationTypeAuditTrigger",
      "through": null
    },
    {
      "className": "NotificationType::Audit",
      "collectionName": "notification_type_audits",
      "foreignKey": "notification_type_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "NotificationTypeAudit",
      "through": null
    },
    {
      "className": "NotificationType::Audit",
      "collectionName": "notification_type_audits",
      "foreignKey": "notification_type_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "NotificationTypeAudit",
      "through": null
    },
    {
      "className": "NotificationType::Translation",
      "collectionName": null,
      "foreignKey": "notification_type_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Notification",
      "collectionName": "notifications",
      "foreignKey": "action_id",
      "name": "notifications",
      "macro": "has_many",
      "resource_name": "Notification",
      "through": "actions"
    },
    {
      "className": "NotificationType::Translation",
      "collectionName": null,
      "foreignKey": "notification_type_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "active",
      "column": {
        "default": "1",
        "name": "active",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "notification_type_actions_count",
      "column": {
        "default": "0",
        "name": "notification_type_actions_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "notification_type_audit_triggers_count",
      "column": {
        "default": "0",
        "name": "notification_type_audit_triggers_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "NotificationTypeAction",
      "collectionName": "notification_type_actions",
      "foreignKey": "notification_type_id",
      "name": "actions",
      "macro": "has_many",
      "resource_name": "NotificationTypeAction",
      "through": null
    },
    {
      "className": "NotificationTypeAuditTrigger",
      "collectionName": "notification_type_audit_triggers",
      "foreignKey": "notification_type_id",
      "name": "audit_triggers",
      "macro": "has_many",
      "resource_name": "NotificationTypeAuditTrigger",
      "through": null
    }
  ],
  "paramKey": "notification_type",
  "primaryKey": "id"
}

/** Frontend model for NotificationType. */
export default class NotificationType extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {boolean} */
  active() {
    return this.readAttributeUnderscore("active")
  }

  /** @returns {boolean} */
  hasActive() {
    const value = this.active()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number} */
  notificationTypeActionsCount() {
    return this.readAttributeUnderscore("notification_type_actions_count")
  }

  /** @returns {boolean} */
  hasNotificationTypeActionsCount() {
    const value = this.notificationTypeActionsCount()

    return this._isPresent(value)
  }

  /** @returns {number} */
  notificationTypeAuditTriggersCount() {
    return this.readAttributeUnderscore("notification_type_audit_triggers_count")
  }

  /** @returns {boolean} */
  hasNotificationTypeAuditTriggersCount() {
    const value = this.notificationTypeAuditTriggersCount()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  auditTest(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "audit_test",
        primaryKey: this.primaryKey(),
        collectionName: "notification_types",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  clone(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "clone",
        primaryKey: this.primaryKey(),
        collectionName: "notification_types",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./notification-type-action.js").default>} */
  actions() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["notification_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "actions",
        model: this,
        modelClass: NotificationTypeAction
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./notification-type-action.js").default>>} */
  loadActions() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["notification_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "actions",
        model: this,
        modelClass: NotificationTypeAction
      },
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./notification-type-audit-trigger.js").default>} */
  auditTriggers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["notification_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "audit_triggers",
        model: this,
        modelClass: NotificationTypeAuditTrigger
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./notification-type-audit-trigger.js").default>>} */
  loadAuditTriggers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["notification_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "audit_triggers",
        model: this,
        modelClass: NotificationTypeAuditTrigger
      },
      {ransack}
    )
  }
}
